import { constants } from "@curai/js-fhir-tools";

export const LanguageNames = {
  [constants.LanguageCode.ENGLISH]: "English",
  [constants.LanguageCode.SPANISH]: "Spanish",
  [constants.LanguageCode.FRENCH]: "French",
  [constants.LanguageCode.GERMAN]: "German",
  [constants.LanguageCode.POLISH]: "Polish",
  [constants.LanguageCode.CHINESE]: "Chinese",
};
